<template>
  <header class="header" :class="{ scrolled: isScrolled }">
    <div class="container">
      <div class="logo">
        <img
          src="@/assets/images/DG2.jpg"
          alt="Diamond Gym logo"
        />
        <a href="">Diamond <span>Gym</span></a>
      </div>
      <button class="ham-burger" @click="toggleNav" :aria-expanded="navOpen" aria-label="Toggle menu">
        <span :class="{ active: navOpen }"></span>
        <span :class="{ active: navOpen }"></span>
        <span :class="{ active: navOpen }"></span>
      </button>
      <nav class="nav" :class="{ open: navOpen }">
        <ul>
          <li><router-link :to="{ path: '/', hash: '#home' }" @click="closeNav">Domov</router-link></li>
          <li><router-link :to="{ path: '/', hash: '#about' }" @click="closeNav">O nás</router-link></li>
          <li><router-link :to="{ path: '/', hash: '#service' }" @click="closeNav">Služby</router-link></li>
          <li><router-link :to="{ path: '/', hash: '#classes' }" @click="closeNav">Možnosti</router-link></li>
          <li><router-link :to="{ path: '/', hash: '#schedule' }" @click="closeNav">Otváracie Hodiny</router-link></li>
          <li><router-link :to="{ path: '/', hash: '#treneri' }" @click="closeNav">Tréneri</router-link></li>
          <li><router-link :to="{ path: '/', hash: '#price' }" @click="closeNav">Cenník</router-link></li>
          <li><router-link :to="{ path: '/', hash: '#contact' }" @click="closeNav">Kontakt</router-link></li>
        </ul>
      </nav>
      <div v-if="navOpen" class="nav-overlay" @click="closeNav"></div>
    </div>
  </header>
</template>

<script>
import { ref, onMounted, onBeforeUnmount } from 'vue'
export default {
  name: "HeaderComponent",
  setup() {
    const navOpen = ref(false)
    const isScrolled = ref(false)

    const toggleNav = () => {
      navOpen.value = !navOpen.value
    }
    const closeNav = () => {
      navOpen.value = false
    }

    const handleScroll = () => {
      isScrolled.value = window.scrollY > 50
    }

    onMounted(() => {
      window.addEventListener('scroll', handleScroll, { passive: true })
    })
    onBeforeUnmount(() => {
      window.removeEventListener('scroll', handleScroll)
    })

    return { navOpen, isScrolled, toggleNav, closeNav }
  }
}
</script>

<style scoped>
.header {
  position: fixed;
  top: 0;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.85);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border-bottom: 2px solid #E8B923;
  z-index: 1000;
  padding: 14px 0;
  transition: background-color 0.3s ease, box-shadow 0.3s ease;
}

.header.scrolled {
  background-color: rgba(0, 0, 0, 0.97);
  box-shadow: 0 4px 20px rgba(232, 185, 35, 0.15);
}

.header .container {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

/* Logo */
.logo {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
}

.logo img {
  width: 80px;
  height: 45px;
  object-fit: contain;
  object-position: center;
}

.logo a {
  font-size: 22px;
  font-weight: 700;
  color: #fff;
  letter-spacing: 0.02em;
  white-space: nowrap;
}

.logo a span {
  color: #E8B923;
}

/* Hamburger */
.ham-burger {
  display: none;
  flex-direction: column;
  justify-content: center;
  gap: 5px;
  cursor: pointer;
  background: none;
  border: none;
  padding: 6px;
  z-index: 1100;
  position: relative;
}

.ham-burger span {
  display: block;
  width: 28px;
  height: 2px;
  background-color: #fff;
  border-radius: 2px;
  transition: transform 0.35s ease, opacity 0.35s ease, background-color 0.3s ease;
  transform-origin: center;
}

/* X animation on open */
.ham-burger span:nth-child(1).active {
  transform: translateY(7px) rotate(45deg);
}
.ham-burger span:nth-child(2).active {
  opacity: 0;
  transform: scaleX(0);
}
.ham-burger span:nth-child(3).active {
  transform: translateY(-7px) rotate(-45deg);
}

/* Nav */
.nav {
  display: flex;
  align-items: center;
}

.nav ul {
  display: flex;
  gap: 20px;
  list-style: none;
}

.nav ul li a {
  position: relative;
  font-size: 14px;
  font-weight: 600;
  padding: 6px 4px;
  color: #bbb;
  letter-spacing: 0.02em;
  white-space: nowrap;
  transition: color 0.25s ease;
}

.nav ul li a::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: -2px;
  width: 100%;
  height: 2px;
  background: #E8B923;
  border-radius: 2px;
  transform: scaleX(0);
  transform-origin: center;
  transition: transform 0.25s ease;
}

.nav ul li a:hover,
.nav ul li a.router-link-active {
  color: #E8B923;
}

.nav ul li a:hover::after,
.nav ul li a.router-link-active::after {
  transform: scaleX(1);
}

/* Overlay */
.nav-overlay {
  display: none;
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1050;
}

/* Mobile */
@media (max-width: 900px) {
  .ham-burger {
    display: flex;
  }

  .nav-overlay {
    display: block;
  }

  .nav {
    position: fixed;
    top: 0;
    right: 0;
    width: 280px;
    height: 100%;
    background-color: #0a0a0a;
    border-left: 1px solid rgba(232, 185, 35, 0.3);
    flex-direction: column;
    justify-content: center;
    gap: 0;
    padding: 80px 32px 40px;
    transform: translateX(100%);
    transition: transform 0.35s cubic-bezier(0.4, 0, 0.2, 1);
    z-index: 1099;
  }

  .nav.open {
    transform: translateX(0);
  }

  .nav ul {
    flex-direction: column;
    gap: 4px;
    width: 100%;
  }

  .nav ul li a {
    font-size: 17px;
    padding: 12px 0;
    display: block;
    color: #bbb;
    border-bottom: 1px solid #1a1a1a;
  }

  .nav ul li:last-child a {
    border-bottom: none;
  }
}

@media (min-width: 901px) {
  .ham-burger {
    display: none;
  }
  .nav-overlay {
    display: none !important;
  }
}

@media (max-width: 420px) {
  .logo a {
    font-size: 18px;
  }

  .logo img {
    width: 64px;
    height: 36px;
  }
}
</style>
